import { Map } from 'immutable'
import { combineReducers } from 'redux'
import { handleActions, combineActions } from 'redux-actions'
import { reducer as demandbase } from './demandbase'
import * as actions from './actions'

const companyByEndUserId = handleActions(
  {
    [actions.receiveEndUserCompanyData]: (state, action) => {
      const { endUserId, data, } = action.payload
      return state.set(endUserId, data)
    },
  },
  Map()
)

const status = handleActions(
  {
    [combineActions(
      actions.fetchEnrichedCompanyDataPending,
      actions.fetchEnrichedCompanyDataNoResult,
      actions.fetchEnrichedCompanyDataSuccess,
      actions.fetchEnrichedCompanyDataFailed,
      actions.fetchEnrichedCompanyDataCancelled
    )]: (state, action) => {
      const { ip, email } = action.payload
      return state.set(`${ip}-${email}`, action.type)
    },
  },
  Map()
)

const company = handleActions(
  {
    [actions.fetchEnrichedCompanyDataSuccess]: (state, action) => {
      const { data, ip, email } = action.payload
      return state.set(`${ip}-${email}`, data)
    },
    [actions.fetchBulkConversationEnrichmentDataSuccess]: (state, action) => {
      const { data } = action.payload
      const map = {}
      Object.keys(data).forEach(conversationId => {
        const user = data[conversationId]
        const { enrichmentSources, enrichmentData } = user
        const ip = enrichmentSources.ip || undefined
        const email = enrichmentSources.email || undefined
        map[`${ip}-${email}`] = enrichmentData
      })
      return state.merge(map)
    },
  },
  Map()
)

const enrichmentSourcesByConversationId = handleActions(
  {
    [actions.fetchEnrichedCompanyDataSuccess]: (state, action) => {
      const { ip, email, conversationId } = action.payload
      return state.set(`${conversationId}`, `${ip}-${email}`)
    },
    [actions.fetchBulkConversationEnrichmentDataSuccess]: (state, action) => {
      const { data } = action.payload
      const map = {}
      Object.keys(data).forEach(conversationId => {
        const user = data[conversationId]
        const { enrichmentSources } = user
        const email = enrichmentSources.email || undefined
        const ip = enrichmentSources.ip || undefined
        map[conversationId] = `${ip}-${email}`
      })
      return state.merge(Map(map))
    }
  },
  Map()
)

const decodedConditions = handleActions({
  [actions.fetchDecodedConditionPending]: (state, action) => {
    const { conditions } = action.payload
    const map = {}
    conditions.forEach(condition => map[condition] = Map({ status: action.type, data: null, error: null }))
    return state.merge(Map(map))
  },
  [actions.fetchDecodedConditionSuccess]: (state, action) => {
    const { conditions } = action.payload
    const map = {}
    conditions.forEach((decrypted, encrypted) => map[encrypted] = Map({ status: action.type, data: decrypted, error: null }))
    return state.merge(Map(map))
  },
  [actions.fetchDecodedConditionFailed]: (state, action) => {
    const { conditions, err } = action.payload
    const map = {}
    conditions.forEach(encrypted => map[encrypted] = Map({ status: action.type, error: err, data: null }))
    return state.merge(Map(map))
  },
}, Map())

export default combineReducers({
  status,
  company,
  demandbase,
  decodedConditions,
  enrichmentSourcesByConversationId,
  companyByEndUserId
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/reducer.js